var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn btn-light-primary",on:{"click":function($event){return _vm.$emit('button-clicked')}}},[_c('span',{staticClass:"svg-icon svg-icon-2x svg-icon-light-primary"},[_c('inline-svg',{attrs:{"src":"/media/svg/icons/Media/Repeat.svg"}})],1),_vm._v(_vm._s(_vm.$t("GROUP.SCHEDULE.CLEAR"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }